import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

export function useContactBankAccounts(contactId: string) {
	/** Query */
	const query = useQuery({
		queryKey: ["contact", "bank-accounts", contactId],
		queryFn: async () => {
			const response = await client.contacts[":contactId"]["bank-accounts"].$get({
				param: { contactId },
			});
			const data = await responseHandler(response);
			return data.bankAccounts;
		},
	});

	/** Return */
	return { ...query, bankAccounts: query.data ?? [] };
}
